import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingMapPreview } from '../../components/NewbuildingMapPreview';
import { getMapImage, getNewbuildingId } from '../../selectors/newbuildingHeader';
import { trackMediaItemClick } from '../../tracking/newbuilding';
import { NewbuildingMapModalContainerLoadable } from '../NewbuildingMapModal';

export const NewbuildingMapContainer: React.FC = () => {
  const mapImage = useSelector(getMapImage);
  const [isOpened, setOpened] = React.useState<boolean>(false);
  const newbuildingId = useSelector(getNewbuildingId);

  const handleOpen = React.useCallback(() => {
    setOpened(true);

    if (newbuildingId) {
      trackMediaItemClick({ target: 'map', newbuildingId });
    }
  }, [newbuildingId]);

  const handleClose = React.useCallback(() => {
    setOpened(false);
  }, []);

  if (!mapImage) {
    return null;
  }

  return (
    <>
      <NewbuildingMapPreview imgSrc={mapImage} onClick={handleOpen} />
      {isOpened && <NewbuildingMapModalContainerLoadable isOpened={isOpened} onClose={handleClose} />}
    </>
  );
};
